import React from 'react';
import { Add } from '@td-client-frontend/icons';
import clsx from 'clsx';

export const AddButton = React.forwardRef<
  HTMLButtonElement,
  {
    onClick: (...args: any) => void;
    label: string;
    hideIcon?: boolean;
    extraClass?: string;
    tabIndex?: number;
    Icon?: React.ReactNode;
  }
>(({ onClick, label, extraClass = '', tabIndex, hideIcon, Icon }, ref) => {
  return (
    <button
      type='button'
      onClick={(e) => onClick(e, ref)}
      ref={ref}
      className={clsx('space-x-2 btn btn-default', extraClass)}
      tabIndex={tabIndex}
      data-testid={`addbutton-button-${label}`}
    >
      {!hideIcon && (Icon || <Add />)}
      <p className='text-primary-500'>{label}</p>
    </button>
  );
});
